import './index.scss';
import React from 'react';
import { lang } from '@umu/ukit-lang';
import { ResourceStatus } from '@umu/umu-types';
import { $location } from '@umu/umu-dom';

export function TranscodingStatus(props: { transStatus?: ResourceStatus }) {
    const { transStatus } = props;
    const transText: { [key: string]: string } = {
        wait_transcoding: lang('文档处理中，请稍后查看'),
        transcoding_fail: lang('文档处理失败'),
    };

    if (!transStatus || transStatus === ResourceStatus.IN_USE) {
        return null;
    }

    return (
        <div className="incompatible-trans">
            <div>
                {transText[transStatus]}
                {transStatus === ResourceStatus.WAIT_TRANSCODING ? (
                    <a onClick={() => $location.reload()}>
                        <i className="icon" />
                        {lang('刷新')}
                    </a>
                ) : null}
            </div>
        </div>
    );
}
